import React, {useState, useEffect, useRef, useContext} from "react";
import {DEFAULT_BLUE} from "../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../constants/common-functions";
import {useHistory} from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import {NO_STRINGIFY} from "../constants/general-constants";
import {store} from '../context/store';
import Header from "../components/Header";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import imageMonitor from "../../images/monitor.png";
import imageMonitorBack from "../../images/monitorback.jpg";
import imageMonitorEnergy from "../../images/monitorenergy.jpg";
import IconNavigator from "../components/IconNavigator";
import ConditionCriticality from "../components/ConditionCriticality";
import AmChartDoughnutIndicatorWhite from "../components/AmChartDoughnutIndicatorWhite";
import AmChartXY from '../components/AmChartXY';
import DashboardSelectorBottom from "../components/DashboardSelectorBottom";

import {useParams} from "react-router-dom";

export default function AssetInformation(){
	const globalState = useContext(store);
	
	const assetId = useParams()["assetId"];
	const [chart1Data, setChart1Data] = useState([]);
	const [chart1Graphs, setChart1Graphs] = useState([]);
	
	useEffect(() => {
		let tempGraphs = [];
		tempGraphs.push({
			name:"Breakdowns",
			seriesType:"SERIES_TYPE_COLUMN",
			yKey:"breakdowns",
			color:"#dd0000",
			columnWidth:"90"
		});
		
		tempGraphs.push({
			name:"Availability",
			seriesType:"SERIES_TYPE_LINE",
			yKey:"availability",
			color:"#009900",
			bullets:true,
			additionalAxisAddress:1
		});
		
		setChart1Graphs(tempGraphs);
		
		let tempData = [];
		
		let weeks = [];
		for(let i=1; i<53; i++){
			weeks.push("Week " + i);
		}
		
		for(let i=0; i<weeks.length; i++){
			tempData.push({
				date:weeks[i],
				breakdowns:Math.round(Math.random()*100),
				availability:Math.round(Math.random()*200 + 100)
			})
		}
		setChart1Data(tempData);
	}, []);

	 const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"80px",
  	left:"0px",
  	bottom:"0px",
  	right:"0px",
  	overflow:"auto"
  };
  
  const warningContainer = {
		display:"flex",
		position:"fixed",
		top:"10px",
		left:"calc(50% - 300px)",
		zIndex:"20000",
		flexDirection:"column"
	};
	
	const warningPrimaryContainer = {
		display:"flex",
		width:"600px",
		height:"40px",
		backgroundColor:"darkred",
		borderRadius:"20px",
		alignItems:"center",
		boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
		justifyContent:"space-around",
		zIndex:"2"
	};
	
	const warningPrimaryLabel = {
		display:"flex",
		fontSize:"16px",
		color:"white"
	};
	
	const assetLeft = {
		display:"flex",
		width:"457px",
		height:"100%",
		flexDirection:"column",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND
	};
	
	const assetPrimary = {
		display:"flex",
		flexGrow:"1",
		overflow:"auto",
		flexDirection:"column"
	};
	
	const assetTitle = {
		display:'flex',
		height:"60px",
		fontSize:"21px",
		color:COLOR_GRAY_BANNER_BACKGROUND,
		alignItems:'center',
		paddingLeft:"20px",
		fontWeight:"bold"
	};
	
	const photoContainer = {
		display:"flex",
		marginLeft:"20px",
		marginTop:"20px",
		marginRight:"20px",
		minHeight:"200px",
		width:"calc(100% - 42px)",
		border:"1px solid darkgrey"
	};
	
	const otherPhotos = {
		display:"flex",
		marginTop:"10px",
		marginLeft:"20px",
		width:"calc(100% - 40px)",
		alignItems:"center"
	};
	
	const otherPhotoArrowContainer = {
		display:'flex',
		width:"30px",
		height:"30px",
		alignItems:"center",
		justifyContent:"space-around",
		backgroundColor:"darkgrey",
		borderRadius:"15px"
	};
	
	const otherPhotoArrow = {
		display:"flex",
		color:COLOR_GRAY_BANNER_BACKGROUND,
		width:"15px",
		height:"15px",
		cursor:'pointer'
	};
	
	const otherPhoto = {
		display:"flex",
		width:"calc(33% - 35px)",
		border:"1px solid darkgrey",
		height:"60px",
		marginLeft:"10px"
	};
	
	const imagePhotoMain = {
		display:"flex",
		width:"100%",
		maxHeight:"200px"
	};
	
	const imagePhotoOther = {
		display:"flex",
		maxWidth:"100%",
		maxHeight:"60px",
		margin:"auto"
	};
	
	const informationTable = {
		display:"flex",
		marginTop:"20px",
		marginLeft:"20px",
		marginRight:"20px",
		width:"calc(100% - 40px)",
		borderLeft:"1px solid darkgrey",
		borderTop:"1px solid darkgrey",
		display:"flex",
		flexDirection:"column"
	};
	
	const informationTableRow = {
		display:"flex",
		width:"100%",
		height:"40px",
		borderBottom:"1px solid darkgrey"
	};
	
	const informationTableColumn = {
		display:'flex',
		height:"100%",
		paddingLeft:"10px",
		width:'calc(50% - 11px)',
		borderRight:"1px solid darkgrey",
		color:"white",
		fontSize:"14px",
		alignItems:"center"
	};
	
	const assetTableItems = [
		{label:'Energy Rating', value:'C'},
		{label:'Replacement Cost', value:'$360'},
		{label:'Serviced By', value:"Roy's Electricals"},
		{label:'Next Service Due', value:'09/09/2030'}
	];
	
	const assetTableItemDisplay = assetTableItems.map((item, index) =>
		<div style={informationTableRow}>
			<div style={informationTableColumn}>
				{item.label}
			</div>
			<div style={informationTableColumn}>
				{item.value}
			</div>
		</div>
	);
	
	const blankFunction = () => {
		
	};
	
	const navigatorIconContainer = {
		marginTop:"10px"
	};
	
	const iconNavigators = [
		{id:"0", label:"User Manual", icon:"cogs", clickFunction:blankFunction},
		{id:"1", label:"Scan", icon:"camera", clickFunction:blankFunction},
		{id:"2", label:"Fact Sheet", icon:"info", clickFunction:blankFunction},
		{id:"3", label:"Resources", icon:"book", clickFunction:blankFunction},
		{id:"5", label:"Dashboards", icon:"chart-pie", clickFunction:blankFunction}
	];
	
	const iconNavigatorDisplay = iconNavigators.map((item, index) =>
		<div style={navigatorIconContainer}>
			<IconNavigator
				id={item.id}
				icon={item.icon}
				label={item.label}
				clickFunction={item.clickFunction}
			/>
		</div>
	);
	
	const iconNavigatorContainer = {
		display:"flex",
		position:"fixed",
		flexDirection:"column",
		top:"80px",
		right:"0px"
	};
	
	const assetTop = {
		display:"flex",
		width:"100%",
		justifyContent:"space-between"
	};
	
	const assetTopLeft = {
		display:"flex",
		flexDirection:"column"
	};
	
	const detailTable = {
		display:"flex",
		marginTop:"0px",
		marginLeft:"20px",
		marginRight:"0px",
		width:"500px",
		borderLeft:"1px solid darkgrey",
		borderTop:"1px solid darkgrey",
		display:"flex",
		flexDirection:"column"
	};
	
	const detailTableRow = {
		display:"flex",
		width:"100%",
		height:"40px",
		borderBottom:"1px solid darkgrey"
	};
	
	const detailTableColumn = {
		display:'flex',
		height:"100%",
		paddingLeft:"10px",
		width:'calc(50% - 11px)',
		borderRight:"1px solid darkgrey",
		color:"black",
		fontSize:"14px",
		alignItems:"center"
	};
	
	const detailTableItems = [
		{label:'Manufacturer', value:'Toshiba'},
		{label:'Model', value:'TSB_MON_89976'},
		{label:'Installation Date', value:'21/09/2019'},
		{label:'Dimensions', value:'1000 x 600 x 20 (mm)'},
		{label:'Location', value:'Hurst Building, F5, R67'},
		{label:'Responsible Person', value:'Roy Bleeks'}
	];
	
	const detailTableItemDisplay = detailTableItems.map((item, index) =>
		<div style={detailTableRow}>
			<div style={detailTableColumn}>
				{item.label}
			</div>
			<div style={detailTableColumn}>
				{item.value}
			</div>
		</div>
	);
	
	const chartData = [
		{id:'1', category:'Utilised', value:'67', color:'white'},
		{id:'2', category:'Non-Utilised', value:'33', color:'black'}
	];
	
	const assetAvailabilityContainer = {
		display:'flex',
		margin:"20px",
		marginRight:"90px",
		flexGrow:"1",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		borderRadius:"5px",
		flexDirection:"column",
		paddingBottom:"15px"
	};
	
	const assetAvailabilityTitle = {
		display:"flex",
		justifyContent:"space-around",
		alignItems:"center",
		color:"white",
		height:"10px",
		paddingTop:"20px",
		fontSize:"16px"
	};
	
	const assetAvailabilityChartContainer = {
		display:"flex",
		width:"200px",
		height:"200px",
		alignSelf:"center",
		marginTop:"-5px"
	};
	
	const assetAvailabilityRow = {
		display:"flex",
		height:"30px",
		width:"220px",
		alignSelf:"center",
		alignItems:"center"
	};
	
	const assetAvailabilityColumnLabel = {
		display:"flex",
		color:"white",
		fontSize:"16px",
		width:"120px"
	};
	
	const assetAvailabilityColumnValue = {
		display:"flex",
		color:"white",
		fontSize:"16px",
		flexDirection:"row-reverse",
		flexGrow:"1"
	};
	
	const chartProps = {
    fontSize:"14px",
    showScrollbar:true,
    showScrollbarY:true,
    showCursor:true,
    showLegend:false,
    marginLeft:0
	};
	
	const costChartContainer = {
		display:"flex",
		width:"calc(100% - 70px)",
		height:"calc(100vh - 400px)",
		marginTop:"-24px"
	};
	
	return (
		
			<div style={thisContainer}>
				<Header/>
				<div style={warningContainer}>
					<div style={warningPrimaryContainer}>
						<div style={warningPrimaryLabel}>
							Note: This information is displaying in a separate browser tab!
						</div>
					</div>
				</div>
				<div style={mainContainer}>
						<div style={assetLeft}>
							<div style={photoContainer}>
								<img src={imageMonitor} style={imagePhotoMain}/>
							</div>
							<div style={otherPhotos}>
								<div style={otherPhotoArrowContainer}>
									<FontAwesomeIcon icon="angle-left" style={otherPhotoArrow}/>
								</div>
								<div style={otherPhoto}>
									<img src={imageMonitor} style={imagePhotoOther}/>
								</div>
								<div style={otherPhoto}>
									<img src={imageMonitorBack} style={imagePhotoOther}/>
								</div>
								<div style={otherPhoto}>
									<img src={imageMonitorEnergy} style={imagePhotoOther}/>
								</div>
								<div style={{...otherPhotoArrowContainer, marginLeft:'10px'}}>
									<FontAwesomeIcon icon="angle-right" style={otherPhotoArrow}/>
								</div>
							</div>
							<div style={informationTable}>
								{assetTableItemDisplay}
							</div>
							<ConditionCriticality
								id="1"
								label="Criticality"
								scoreLabel="LOW"
								score="1"
							/>
							<ConditionCriticality
								id="1"
								label="Condition"
								scoreLabel="POOR"
								score="4"
							/>
						</div>
						<div style={assetPrimary}>
							<div style={assetTop}>
								<div style={assetTopLeft}>
									<div style={assetTitle}>
										98776554:  Computer Monitor M7788
									</div>	
									<div style={detailTable}>
										{detailTableItemDisplay}
									</div>
								</div>
								<div style={assetAvailabilityContainer}>
									<div style={assetAvailabilityTitle}>
										Availability
									</div>
									<div style={assetAvailabilityChartContainer}>
										<AmChartDoughnutIndicatorWhite
											id="assetavailabilitydoughnut"
											percentage="76"
											width="140"
											height="140"
										/>
									</div>
									<div style={{...assetAvailabilityRow, marginTop:'-12px'}}>
										<div style={assetAvailabilityColumnLabel}>
											Total Downtime
										</div>
										<div style={assetAvailabilityColumnValue}>
											10.2 hours
										</div>
									</div>
									<div style={assetAvailabilityRow}>
										<div style={assetAvailabilityColumnLabel}>
											No. Breakdowns
										</div>
										<div style={assetAvailabilityColumnValue}>
											14
										</div>
									</div>
								</div>
							</div>
							
							<div style={costChartContainer}>
								<AmChartXY
									chartId="assetinformationlinechart"
									width="100%"
									height="100%"
									props={chartProps}
									chartData={chart1Data}
									chartGraphs={chart1Graphs}
									categoryType="CATEGORY_TYPE_CATEGORY"
									categoryKey="date"
									labelsRotate="true"
									xAxisTitle="Time Line"
									yAxisTitle="Availability/Breakdowns"
								>
								</AmChartXY>
							</div>	
						</div>
						<div style={iconNavigatorContainer}>
							{iconNavigatorDisplay}
						</div>
				</div><DashboardSelectorBottom
					title="Availability/Breakdowns"
				/>
			</div>
	);
}